/* src/app/modules/display/components/menus/spotlight-menu/spotlight-menu-section-overflow-calculator/spotlight-menu-section-overflow-calculator.component.scss */
.menu-section-overflow-calculator {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
}
/*# sourceMappingURL=spotlight-menu-section-overflow-calculator.component.css.map */
